import { Input, type InputProps, Tooltip } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useEffect, useState } from 'react';
import { defaultIconStyle } from '../theme/styling/iconStyling';

interface SearchFieldProps extends InputProps {
	placeholder: string;
	tooltip?: string;
	onDelayComplete: (value: string) => void;
	width?: string;
	isWhite?: boolean;
}

export function SearchField({
	placeholder,
	onDelayComplete,
	width = '20vw',
	variant = 'borderless-filled',
	tooltip,
	...inputProps
}: SearchFieldProps) {
	const [internalValue, setInternalValue] = useState('');

	useEffect(() => {
		const handler = setTimeout(() => {
			onDelayComplete(internalValue);
		}, 500); // 1/2 second debounce

		return () => {
			clearTimeout(handler);
		};
	}, [internalValue, onDelayComplete]);

	return (
		<Tooltip label={tooltip ?? placeholder}>
			<Input
				{...inputProps}
				variant={variant}
				placeholder={placeholder}
				value={internalValue}
				onChange={(event) => {
					setInternalValue(event.currentTarget.value);
				}}
				leftSection={<IconSearch {...defaultIconStyle} />}
				w={width}
			/>
		</Tooltip>
	);
}
